export const loadState = () => {
  if (!localStorage) {
    console.log(
      '[Local storage] State not loaded - Local storage not supported',
    );
    return undefined;
  }

  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    console.log('[Local storage] State loaded');
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

export const saveState = state => {
  if (!localStorage) {
    console.log(
      '[Local storage] State not saved - Local storage not supported',
    );
    return;
  }

  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
    console.log('[Local storage] State saved');
  } catch (e) {
    // ignore
  }
};

export const clearState = () => {
  if (localStorage) {
    localStorage.removeItem('state');
    console.log('[Local storage] State cleared');
  } else {
    console.log(
      '[Local storage] State not cleared - Local storage not supported',
    );
  }
};



// WEBPACK FOOTER //
// ./src/localStorage.js